import { getCookie } from 'src/misc/cookies';

export const isDarkModeEnabled = () => getCookie('dark_mode') === 'true';
